// extracted by mini-css-extract-plugin
export default {"buttonsolid":"styles_buttonsolid__KQC6M","dark":"styles_dark__c9TLJ","disabled":"styles_disabled__ts7fy"};